import React, { useState, forwardRef, useEffect } from 'react';
import apiService from './../../Auth/apiService';
import { useNavigate, NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Container, ButtonGroup } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import MenuInformeDdhh from './MenuInformeDdhh';
import ButtonsMenu from './../Utils/ButtonsMenu';
import { useAuth } from './../../Auth/AuthContext';
import { FaCalendar, FaList, FaSearch } from 'react-icons/fa';


const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' data-tooltip-id='tooltiparriba' data-tooltip-content="Seleccionte fecha" tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none', width: 'auto' }} />
        <FaCalendar/>
    </button>
    ));

export default function InformeAudiencias(){
    const { token, rol } = useAuth();
    const navigate = useNavigate();
    const fecha = new Date();
    const [Cargando, setCargando] = useState(false);
    const [datosAyuda, setDatosAyuda] = useState([]);
    
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [swalProps, setSwalProps] = useState();
    
    async function onSubmit(data) {
        await fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'), 
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    }

    async function fetchData(FechaI, FechaF) {
        setCargando(true);
        const url = `/ddhh/informes/consultaraudiencias?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;        
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            if (result && result.length > 0) {
                setDatosAyuda(result);
            } else {
                setDatosAyuda([]);
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            }
            
        } catch (error) {
            if (error.response?.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de audiencias.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
    }
    function verAtencion(row, verAtencionesPersona) {
        return (
            <div>
                <button 
                    type="button" 
                    onClick={() => verAtencionesPersona(row)} 
                    style={{ backgroundColor: 'skyblue' }} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Ver atenciones de la persona"
                >
                    <FaList />
                </button>
            </div>
        );
    }
    
    async function exportaExcel() {
        try {
            const xlsxMod = await import('xlsx');
            const XLSX = xlsxMod?.default ?? xlsxMod;
            // Define column titles in desired order
            const headers = [
                'Tipo documento', 'Identificacion', 'Primer Nombre', 'Segundo Nombre', 'Primer Apellido', 'Segundo Apellido',
                'Edad', 'Sexo', 'Fecha Registro SIPOD', 'Tipo de Entrega', 'Tipo AH', 'Tipo Naturaleza', 'Naturaleza Entrega',
                'Ayuda', 'Producto', 'Entidad', 'Fecha', 'Hora', 'Cantidad', 'Valor', 'Usuario', 'Observaciones',
                'Fecha creacion', 'Sede', 'Telefono 2', 'Telefono 1', 'Discapacidad', 'OSIEGD', 'Gestante', 'Minoria',
                'Enf. Terminal', 'Resguardo', 'Con.Comunitario', 'Asiste Escuela', 'Asistia Escuela', 'Tipo Estudio',
                'Autos de la Corte', 'Ultimo Grado', 'Direccion', 'Barrio', 'Asentamiento', 'Zona', 'Comuna',
                'Fecha Nacimiento', 'Cabeza de Hogar', 'Id detalle', 'Estado atención', 'hechos_victimizantes', 'Nacionalidad'
            ];

            // Map data to match header order
            const wsData = filteredData.map(row => {
                let fechaValue = row.det_fecha;
                if (Array.isArray(fechaValue) && fechaValue.length > 0) {
                    fechaValue = fechaValue[0];
                }
                if (fechaValue && !Number.isNaN(Date.parse(fechaValue))) {
                    const dateObj = new Date(fechaValue);
                    fechaValue = (dateObj - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                }
                let fechaRegistroSipod = row.per_fecharegistrosipod;
                if (Array.isArray(fechaRegistroSipod) && fechaRegistroSipod.length > 0) {
                    fechaRegistroSipod = fechaRegistroSipod[0];
                }
                if (fechaRegistroSipod && !Number.isNaN(Date.parse(fechaRegistroSipod))) {
                    const dateObj = new Date(fechaRegistroSipod);
                    fechaRegistroSipod = (dateObj - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                }
                let fechaNacimiento = row.fechanac;
                if (Array.isArray(fechaNacimiento) && fechaNacimiento.length > 0) {
                    fechaNacimiento = fechaNacimiento[0];
                }
                if (fechaNacimiento && !Number.isNaN(Date.parse(fechaNacimiento))) {
                    const dateObj = new Date(fechaNacimiento);
                    fechaNacimiento = (dateObj - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                }
                let fechaCreacionSistema = row.det_creacionsistema;
                if (Array.isArray(fechaCreacionSistema) && fechaCreacionSistema.length > 0) {
                    fechaCreacionSistema = fechaCreacionSistema[0];
                }
                if (fechaCreacionSistema && !Number.isNaN(Date.parse(fechaCreacionSistema))) {
                    const dateObj = new Date(fechaCreacionSistema);
                    fechaCreacionSistema = (dateObj - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                }
                return [
                    row.tip_tipoidentificacion,
                    row.per_idpersona,
                    row.per_nombre1,
                    row.per_nombre2,
                    row.per_apellido1,
                    row.per_apellido2,
                    row.per_edad,
                    row.per_sexo,
                    fechaRegistroSipod,
                    row.tip_tipoentrega,
                    row.tip_tipoahu,
                    row.tip_tiponaturaleza,
                    row.tip_naturaleza,
                    row.ayu_ayuda,
                    row.tip_atencion,
                    row.ent_entidad,
                    fechaValue,
                    row.det_horaatencion,
                    row.det_cantidad,
                    row.det_valor,
                    row.usr_nombre,
                    row.det_observaciones,
                    fechaCreacionSistema,
                    row.det_sede,
                    row.cab_telefono1,
                    row.cab_telefono2,
                    row.dis_discapacidad,
                    row.per_lgtbi,
                    row.per_gestante,
                    row.min_minoria,
                    row.per_terminal,
                    row.per_resguardo,
                    row.per_concomunitario,
                    row.per_asisteescuela,
                    row.per_asistiaescuela,
                    row.tip_descripcion,
                    row.tip_tipoauto,
                    row.per_ultimogrado,
                    row.cab_direccion,
                    row.bar_barrio,
                    row.ase_asentamiento,
                    row.zon_zona,
                    row.comuna,
                    fechaNacimiento,
                    row.gru_idcabezafamilia,
                    row.iddetalleatencion,
                    row.ate_atencioncerrada,
                    row.hechos_victimizantes,
                    row.nacionalidad
                ];
            });

            // Add header row
            wsData.unshift(headers);

            // Create worksheet from array of arrays
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'InformeAyudas');
            const date = new Date();
            await XLSX.writeFile(wb, `InformeAyudas_${date.toLocaleDateString('co-CO')}.xlsx`);
        } catch (error) {
            console.error('Error exporting excel:', error);
        }
    }

    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/ddhh/informes/consultaraudiencias?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            const currentDate = new Date().toLocaleDateString('co-CO');
            link.setAttribute('download', `Audiencias_${currentDate}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }        
    }    
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    useEffect(() => {
        if (rol !== '2') {
          navigate('/dashboard');
        }
      }, [rol, navigate]);
    const [filters, setFilters] = useState({
        tip_tipoidentificacion: '',
        per_sexo: '',
        dis_discapacidad: '',
        per_gestante: '',
        min_minoria: '',
        per_terminal: '',
        per_resguardo: '',
        per_concomunitario: '',
        bar_barrio: '',
        zon_zona: '',
        comuna: '',
        usr_nombre: '',
        ayu_ayuda: '',
        tip_tipoahu: '',
        tip_tipoentrega: '',
        tip_tiponaturaleza: '',
        tip_naturaleza: '',
    });
    // Filtrado de datos
    const filteredData = datosAyuda.filter(row =>
        (!filters.tip_tipoidentificacion || row.tip_tipoidentificacion === filters.tip_tipoidentificacion) &&
        (!filters.per_sexo || row.per_sexo === filters.per_sexo) &&
        (!filters.dis_discapacidad || row.dis_discapacidad === filters.dis_discapacidad) &&
        (!filters.per_gestante || row.per_gestante === filters.per_gestante) &&
        (!filters.min_minoria || row.min_minoria === filters.min_minoria) &&
        (!filters.per_terminal || row.per_terminal === filters.per_terminal) &&
        (!filters.per_resguardo || row.per_resguardo === filters.per_resguardo) &&
        (!filters.per_concomunitario || row.per_concomunitario === filters.per_concomunitario) &&
        (!filters.bar_barrio || row.bar_barrio === filters.bar_barrio) &&
        (!filters.zon_zona || row.zon_zona === filters.zon_zona) &&
        (!filters.comuna || row.comuna === filters.comuna) &&
        (!filters.usr_nombre || row.usr_nombre === filters.usr_nombre) &&
        (!filters.ayu_ayuda || row.ayu_ayuda === filters.ayu_ayuda) &&
        (!filters.tip_atencion || row.tip_atencion === filters.tip_atencion) &&
        (!filters.tip_tipoahu || row.tip_tipoahu === filters.tip_tipoahu) &&
        (!filters.tip_tipoentrega || row.tip_tipoentrega === filters.tip_tipoentrega) &&
        (!filters.tip_tiponaturaleza || row.tip_tiponaturaleza === filters.tip_tiponaturaleza) &&
        (!filters.tip_naturaleza || row.tip_naturaleza === filters.tip_naturaleza)
    );

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [filters, datosAyuda]);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe audiencias DDHH</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Audiencias</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuInformeDdhh/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                    <ButtonsMenu data={filteredData} titulo={'Informe ayudas'} exportarCSV={exportarCSV} exportaExcel={exportaExcel}/>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Container>
                                            <ButtonGroup aria-label="Basic example">
                                                <label htmlFor="FechaInicial">
                                                    <Controller
                                                        control={control}
                                                        name="FechaInicial"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                id="FechaInicial"
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    /></label>
                                                    {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                                
                                                <label htmlFor="FechaFinal">
                                                    <Controller
                                                        control={control}
                                                        name="FechaFinal"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                id="FechaFinal"
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />{errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                                </label>                                                
                                                <button
                                                    type="submit"
                                                    className="img-square elevation-1"
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        padding: '2px 12px',
                                                        height: 38,
                                                        minWidth: '80px',
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #6daff1ff',
                                                        borderRadius: 4,
                                                        background: '#abbdcfff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Consultar"
                                                >
                                                    <FaSearch /> Buscar
                                                </button>
                                            </ButtonGroup>
                                        </Container>
                                    </form>
                                </div>
                                
                                {datosAyuda && datosAyuda.length > 0 && <div className="card-body table-responsive p-0">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Tipo documento</th>
                                                <th>Identificacion</th>
                                                <th>Primer Nombre</th>
                                                <th>Segundo Nombre</th>
                                                <th>Primer Apellido</th>
                                                <th>Segundo Apellido</th>
                                                <th>Edad</th>
                                                <th>Sexo</th>
                                                <th>Fecha Registro SIPOD</th>
                                                <th>Tipo de Entrega</th>
                                                <th>Tipo AH</th>
                                                <th>Tipo Naturaleza</th>
                                                <th>Naturaleza Entrega</th>
                                                <th>Ayuda</th>
                                                <th>Producto</th>
                                                <th>Entidad</th>
                                                <th>Fecha</th>
                                                <th>Hora</th>
                                                <th>Cantidad</th>
                                                <th>Valor</th>
                                                <th>Usuario</th>
                                                <th>Observaciones</th>
                                                <th>Fecha creacion</th>
                                                <th>Sede</th>
                                                <th>Telefono 2</th>
                                                <th>Telefono 1</th>
                                                <th>Discapacidad</th>
                                                <th>OSIEGD</th>
                                                <th>Gestante</th>
                                                <th>Minoria</th>
                                                <th>Enf. Terminal</th>
                                                <th>Resguardo</th>
                                                <th>Con.Comunitario</th>
                                                <th>Asiste Escuela</th>
                                                <th>Asistia Escuela</th>
                                                <th>Tipo Estudio</th>
                                                <th>Autos de la Corte</th>
                                                <th>Ultimo Grado</th>
                                                <th>Direccion</th>
                                                <th>Barrio</th>
                                                <th>Asentamiento</th>
                                                <th>Zona</th>
                                                <th>Comuna</th>
                                                <th>Fecha Nacimiento</th>
                                                <th>Cabeza de Hogar</th>
                                                <th>Id detalle</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.tip_tipoidentificacion}
                                                        onChange={e => setFilters(f => ({ ...f, tip_tipoidentificacion: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_tipoidentificacion).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.per_sexo}
                                                        onChange={e => setFilters(f => ({ ...f, per_sexo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.per_sexo).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.tip_tipoentrega}
                                                        onChange={e => setFilters(f => ({ ...f, tip_tipoentrega: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_tipoentrega).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.tip_tipoahu}
                                                        onChange={e => setFilters(f => ({ ...f, tip_tipoahu: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_tipoahu).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.tip_tiponaturaleza}
                                                        onChange={e => setFilters(f => ({ ...f, tip_tiponaturaleza: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_tiponaturaleza).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.tip_naturaleza}
                                                        onChange={e => setFilters(f => ({ ...f, tip_naturaleza: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_naturaleza).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.ayu_ayuda}
                                                        onChange={e => setFilters(f => ({ ...f, ayu_ayuda: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.ayu_ayuda).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.tip_atencion}
                                                        onChange={e => setFilters(f => ({ ...f, tip_atencion: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.tip_atencion).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.usr_nombre}
                                                        onChange={e => setFilters(f => ({ ...f, usr_nombre: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.usr_nombre).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.dis_discapacidad}
                                                        onChange={e => setFilters(f => ({ ...f, dis_discapacidad: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.dis_discapacidad).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.per_gestante}
                                                        onChange={e => setFilters(f => ({ ...f, per_gestante: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.per_gestante).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.min_minoria}
                                                        onChange={e => setFilters(f => ({ ...f, min_minoria: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.min_minoria).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_terminal}
                                                        onChange={e => setFilters(f => ({ ...f, per_terminal: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.per_terminal).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_resguardo}
                                                        onChange={e => setFilters(f => ({ ...f, per_resguardo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.per_resguardo).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_concomunitario}
                                                        onChange={e => setFilters(f => ({ ...f, per_concomunitario: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.per_concomunitario).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.bar_barrio}
                                                        onChange={e => setFilters(f => ({ ...f, bar_barrio: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.bar_barrio).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.zon_zona}
                                                        onChange={e => setFilters(f => ({ ...f, zon_zona: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.zon_zona).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.comuna}
                                                        onChange={e => setFilters(f => ({ ...f, comuna: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosAyuda.map(row => row.comuna).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row) => {
                                                let fechaDisplay = '';
                                                if (row.det_fecha instanceof Date) {
                                                    fechaDisplay = row.det_fecha.toLocaleDateString('es-CO');
                                                } else if (Array.isArray(row.det_fecha) && row.det_fecha.length > 0 && row.det_fecha[0]) {
                                                    fechaDisplay = new Date(row.det_fecha[0]).toLocaleDateString('es-CO');
                                                } else {
                                                    fechaDisplay = row.det_fecha || '';
                                                }
                                                return (
                                                    <tr key={`${row.iddetalleatencion || 'sin-id'}-${row.per_idpersona || 'sin-persona'}-${row.det_fecha || 'sin-fecha'}`}>
                                                        <td>{verAtencion(row, verAtencionesPersona)}</td>
                                                        <td>{row.tip_tipoidentificacion}</td>
                                                        <td>{row.per_idpersona}</td>
                                                        <td>{row.per_nombre1}</td>
                                                        <td>{row.per_nombre2}</td>
                                                        <td>{row.per_apellido1}</td>
                                                        <td>{row.per_apellido2}</td>
                                                        <td>{row.per_edad}</td>
                                                        <td>{row.per_sexo}</td>
                                                        <td>{row.per_fecharegistrosipod}</td>
                                                        <td>{row.tip_tipoentrega}</td>
                                                        <td>{row.tip_tipoahu}</td>
                                                        <td>{row.tip_tiponaturaleza}</td>
                                                        <td>{row.tip_naturaleza}</td>
                                                        <td>{row.ayu_ayuda}</td>
                                                        <td>{row.tip_atencion}</td>
                                                        <td>{row.ent_entidad}</td>
                                                        <td>{fechaDisplay}</td>
                                                        <td>{row.det_horaatencion}</td>
                                                        <td>{row.det_cantidad}</td>
                                                        <td>{row.det_valor}</td>
                                                        <td>{row.usr_nombre}</td>
                                                        <td>{row.det_observaciones}</td>
                                                        <td>{row.det_creacionsistema}</td>
                                                        <td>{row.det_sede}</td>
                                                        <td>{row.cab_telefono1}</td>
                                                        <td>{row.cab_telefono2}</td>
                                                        <td>{row.dis_discapacidad}</td>
                                                        <td>{row.per_lgtbi}</td>
                                                        <td>{row.per_gestante}</td>
                                                        <td>{row.min_minoria}</td>
                                                        <td>{row.per_terminal}</td>
                                                        <td>{row.per_resguardo}</td>
                                                        <td>{row.per_concomunitario}</td>
                                                        <td>{row.per_asisteescuela}</td>
                                                        <td>{row.per_asistiaescuela}</td>
                                                        <td>{row.tip_descripcion}</td>
                                                        <td>{row.tip_tipoauto}</td>
                                                        <td>{row.per_ultimogrado}</td>
                                                        <td>{row.cab_direccion}</td>
                                                        <td>{row.bar_barrio}</td>
                                                        <td>{row.ase_asentamiento}</td>
                                                        <td>{row.zon_zona}</td>
                                                        <td>{row.comuna}</td>
                                                        <td>{row.fechanac}</td>
                                                        <td>{row.gru_idcabezafamilia}</td>
                                                        <td>{row.iddetalleatencion}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}